import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';
import Spinner from '../../components/common/Spinner';
import { consumirApi } from '../../utils/consumoApi';
import { useState, useEffect } from 'react';

const Contratos = () => {
    const [contratosAnuales, setContratosAnuales] = useState([]);
    const [contratosMensuales, setContratosMensuales] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [year, setYear] = useState(2025);
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

    const fetchData = async (selectedYear) => {
        setCargando(true);
        try {
            const respuestaAnual = await consumirApi('GET', `reportes/contratos-anuales/${idEmpresa}`);
            const respuestaMensual = await consumirApi('GET', `reportes/contratos-mensuales/${idEmpresa}/${selectedYear}`);
            if (respuestaAnual.success) {
                setContratosAnuales(respuestaAnual.data);
            }
            if (respuestaMensual.success) {
                setContratosMensuales(respuestaMensual.data)
            }
        } catch (error) {
            console.error("Error al obtener los datos:", error);
        } finally {
            setCargando(false);
        }
    };

    const changeYear = async(newYear) => {
        setYear(newYear);
        try {
            const respuestaMensual = await consumirApi('GET', `reportes/contratos-mensuales/${idEmpresa}/${newYear}`);
            if (respuestaMensual.success) {
                setContratosMensuales(respuestaMensual.data)
            }
        } catch (error) {
            console.error("Error al obtener los datos:", error);
        } 
    }

    useEffect(() => {
        fetchData(year);
    }, []);

    return (
        <div style={{ maxHeight: 'calc(100vh - 40px)'}} className="overflow-y-auto flex flex-col items-center gap-6 w-full p-6 bg-slate-200 text-gray-500">  
            {cargando ? (
                <Spinner />
            ) : (
                <div className="flex flex-col lg:flex-row justify-center items-center lg:items-start gap-8 w-full overflow-x-auto">
                {/* Gráfico por Mes */}
                <div className="min-w-[450px] overflow-auto w-full lg:w-1/2 bg-white shadow-lg rounded-2xl p-6">
                    <div className='flex justify-center items-center gap-10'>
                        <h2 className="text-2xl font-bold text-center">Contratos por Mes</h2>
                        <div>
                            <input 
                                type="number" 
                                value={year} 
                                onChange={(e) => changeYear(e.target.value)} 
                                className="p-2 border rounded-md"
                            />
                        </div>
                    </div>
            
                    {contratosMensuales.length > 0 ? (
                        <div className="overflow-x-auto">
                            <ResponsiveContainer width="100%" height={350}>
                                <BarChart 
                                    data={contratosMensuales}
                                    margin={{ top: 10, right: 30, left: 20, bottom: 40 }}
                                    barCategoryGap={30}
                                >
                                    <XAxis dataKey="mes" />
                                    <YAxis allowDecimals={false} />
                                    <Legend />
                                    <Bar dataKey="total" fill="#E11D48" radius={[5, 5, 0, 0]} name="Contratos">
                                        <LabelList dataKey="total" position="outsideTop" fill="white" fontSize={20} />
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : (
                        <p className="text-center text-gray-500">No hay datos disponibles</p>
                    )}
                </div>
            
                {/* Gráfico por Año */}
                <div className="min-w-[500px] w-full lg:w-1/2 bg-white shadow-lg rounded-2xl p-6">
                    <h2 className="text-2xl font-bold text-center mb-4">Contratos por Año</h2>
                    {contratosAnuales.length > 0 ? (
                        <div className="overflow-x-auto">
                            <ResponsiveContainer width="100%" height={350}>
                                <BarChart 
                                    data={contratosAnuales}
                                    margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                                >
                                    <XAxis dataKey="anio" />
                                    <YAxis allowDecimals={false} />
                                    <Legend />
                                    <Bar dataKey="total" fill="#4F46E5" radius={[5, 5, 0, 0]} name="Contratos">
                                        <LabelList dataKey="total" position="outsideTop" fill="white" fontSize={20} />
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    ) : (
                        <p className="text-center text-gray-500">No hay datos disponibles</p>
                    )}
                </div>
            </div>
            
            )}
        </div>
    );
}

export default Contratos;
